import app from '../../../scripts/app';
import template from './about-building.jade';

app.directive('cianAfAboutBuilding', () => {
  return {
    template,
    scope: {},
    bindToController: {
      category: '@',
      categoryInfo: '=',
      ad: '=',
      form: '=',
    },
    controller: [
      'btiService',
      'simpleFormService',
      function (btiService, simpleFormService) {
        this.showBtiTooltip = () => btiService.isBtiProcessed();
        this.isObjectPreviewVisible = simpleFormService.isAboutBuildingPreviewVisible;
      },
    ],
    controllerAs: 'aboutObjectCtrl',
    replace: true,
  };
});
